import Guid from "~/helpers/guid";
import IRepo from "~/interfaces/repo";
import TrackedModel from "~/models/tracked/trackedModel";
import Visualization from "~/models/visualizations/visualization";
import VisualizationDataFusionPoint from "~/models/visualizations/visualizationDataFusionPoint";
import Repo from "~/state/modules/repo";
import {
  CompatibleDates,
  CompatibleMultiSelect,
  CompatibleNumbers,
  CompatibleTexts
} from "../../../formability/visualizationBuilder/enums/data-fusion-compatible-type";
import VisualizationSourceDataPoint from "~/models/visualizations/visualizationSourceDataPoint";
import { StaticDataPointLabels } from "../../../formability/visualizationBuilder/enums/data-point-static-type";
import Selected from "../../../formability/visualizationBuilder/store/modules/selected";

export default class DataPointReference extends TrackedModel {
  rootModel: Visualization;
  parent: VisualizationDataFusionPoint;
  reference_id: string;
  visualization_source_id: string;

  constructor(reference_id, visualization_source_id, visualization) {
    super();
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('reference_id', reference_id);
    this.defineProperty('visualization_source_id', visualization_source_id);
    this.rootModel = visualization || Selected.visualization.get();
  }

  static repo: IRepo<DataPointReference> = new Repo<DataPointReference>('dataPointReferences', DataPointReference, {});
  repo: IRepo<this>;

  get displayName(): string {
    return '';
  }

  get referencedVisualizationSource() {
    return this.visualization_source_id ? this.rootModel.visualizationSources.find(s => s.client_id === this.visualization_source_id) : null;
  }

  get referencedDataPoint(): VisualizationSourceDataPoint {
    return this.referencedVisualizationSource ? this.referencedVisualizationSource.allMeasuresDimensionsBuiltins.find(dp => dp.referenced_client_id === this.reference_id) : null;
  }

  get elementType() {
    return this.referencedDataPoint ? this.referencedDataPoint.elementType : null;
  }

  get compatibleList() {
    if (!this.reference_id || Object.values(StaticDataPointLabels).includes(this.reference_id)) {
      return [];
    }

    if (CompatibleMultiSelect.includes(this.elementType)) {
      return CompatibleMultiSelect;
    }

    if (CompatibleNumbers.includes(this.elementType)) {
      return CompatibleNumbers;
    }

    if (CompatibleDates.includes(this.elementType)) {
      return CompatibleDates;
    }

    if (CompatibleTexts.includes(this.elementType)) {
      return CompatibleTexts;
    }
  }

  get compatibleTypes() {
    return null;
  }
}